var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"reverse",attrs:{"type":"button"},on:{"click":function($event){return _vm.openHelp(_vm.contentId)}}},[_vm._v("도움말")])}
var staticRenderFns = []

export { render, staticRenderFns }